import html from '../legacy/tls.html?raw';
import { LegacyHtmlPage } from './LegacyHtmlPage';

export function Tls() {
  return <LegacyHtmlPage slug="tls" title="TLS & X.509 Certificates" html={html} />;
}
